const h = Symbol("element resolver updated");
class c {
  constructor(e, { selector: r } = { selector: "" }) {
    this._element = null, this._selector = "", this.mutationCallback = (s) => {
      let t = !1;
      s.forEach((l) => {
        if (!t) {
          if (l.type === "childList") {
            const o = this.element && [...l.removedNodes].includes(this.element), i = !!this.selector && [...l.addedNodes].some(this.elementIsSelected);
            t = t || o || i;
          }
          if (l.type === "attributes") {
            const o = l.target === this.element, i = !!this.selector && this.elementIsSelected(l.target);
            t = t || o || i;
          }
        }
      }), t && this.resolveElement();
    }, this.elementIsSelected = (s) => {
      var t;
      return this.selectorIsId ? (s == null ? void 0 : s.id) === this.selectorAsId : (t = s == null ? void 0 : s.matches) == null ? void 0 : t.call(s, this.selector);
    }, this.host = e, this.selector = r, this.observer = new MutationObserver(this.mutationCallback), this.host.addController(this);
  }
  get element() {
    return this._element;
  }
  set element(e) {
    if (e === this.element) return;
    const r = this.element;
    this._element = e, this.host.requestUpdate(h, r);
  }
  get selector() {
    return this._selector;
  }
  set selector(e) {
    e !== this.selector && (this.releaseElement(), this._selector = e, this.resolveElement());
  }
  get selectorAsId() {
    return this.selector.slice(1);
  }
  get selectorIsId() {
    return !!this.selector && this.selector.startsWith("#");
  }
  hostConnected() {
    this.resolveElement(), this.observer.observe(this.host.getRootNode(), { subtree: !0, childList: !0, attributes: !0 });
  }
  hostDisconnected() {
    this.releaseElement(), this.observer.disconnect();
  }
  resolveElement() {
    if (!this.selector) return void this.releaseElement();
    const e = this.host.getRootNode();
    this.element = this.selectorIsId ? e.getElementById(this.selectorAsId) : e.querySelector(this.selector);
  }
  releaseElement() {
    this.element = null;
  }
}
export {
  c as E,
  h as e
};
//# sourceMappingURL=ElementResolution-BiRkFPHH.js.map
